import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IUploadedImageAsset, InputAsset } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  createSpaceAssets: {
    spaceAssets: IUploadedImageAsset[]
  }
}

const mutateHandler = handleFetchResult<IPayload, IUploadedImageAsset[]>({
  handler: (data) => data.createSpaceAssets.spaceAssets,
  name: 'Upload assets',
})

export default function createSpaceAssets(input: {
  assets: InputAsset[]
  spaceId: string
}): Promise<IUploadedImageAsset[]> {
  return client.gql
    .mutate({
      mutation,
      variables: { input },
    })
    .then(mutateHandler)
}

const mutation = gql`
  mutation createSpaceAssets($input: CreateSpaceAssetsInput!) {
    createSpaceAssets(input: $input) {
      spaceAssets {
        id
        url
        fileName
        updatedAt
        isDefault
      }
    }
  }
`
